<div class="header-navigation container-large container-fluid">


  <div class="main-navigation-wrapper ">
    <div class="main-nav">
      <div id="nav-start">
        <button class="button-aside visible-md hidden-lg open-side-menu" type="button" aria-label="Open navigation menu"
          (click)="showMobileMenu()">
          <i class="fa fa-bars"></i>
        </button>
        <a  href="http://{{currentCity}}.{{getHost()}}/{{this.language == 'en' ? 'en' : ''}}"  class="zavedenia-com-logo" title="{{this.word[this.language].venues}}">
          <ng-content *ngIf="hasLoaded">
            <img *ngIf="!this.isOutside" class="logo" [src]="'assets/images/zavedenia-logo.svg'" alt="{{this.word[this.language].venues}}">
            <img *ngIf="this.currentCity == 'skopje'" [src]="'assets/images/bookylogo.svg'" alt="booky.mk logo" class="logo booky">
            <img *ngIf="this.currentCity == 'beograd'" [src]="'assets/images/booknowlogo.svg'" alt="booknow logo" class="logo booky">
          </ng-content>
        </a>
        <div id="citiesDropDown" (click)="citiesDropDown()" class="hidden-md hidden-xs">
          <a id="choose-city" href="javascript:;">{{this.word[this.language][currentCity]}}
            <i *ngIf="!isOutside" class="fa fa-caret-down"></i>
          </a>
          <div *ngIf="!isOutside" class="header-dropdown-wrapper">
            <div class="zavedenia-city">
              <ul class="city-listing">
                <li>
                  <h5>{{this.word[this.language].choose}} {{this.word[this.language].city}}</h5>
                </li>
                <li id="zavedenia.com home">
                  <a href="http://{{getHost()}}/"
                    title="{{this.word[this.language].venues}}">{{this.word[this.language].zavedeniaBG}}
                    {{this.word[this.language].home}}</a>
                </li>
                <li id="sofia">
                  <a href="http://sofia.{{getHost()}}/"
                    title="{{this.word[this.language].sofia}}, {{this.word[this.language].venues}}">
                    {{this.word[this.language].sofia}}</a>
                </li>
                <li id="plovdiv">
                  <a href="http://plovdiv.{{getHost()}}/"
                    title="{{this.word[this.language].plovdiv}}, {{this.word[this.language].venues}}">
                    {{this.word[this.language].plovdiv}}</a>
                </li>
                <li id="varna">
                  <a href="http://varna.{{getHost()}}/"
                    title="{{this.word[this.language].varna}}, {{this.word[this.language].venues}}">
                    {{this.word[this.language].varna}}</a>
                </li>
                <li id="burgas">
                  <a href="http://burgas.{{getHost()}}/"
                    title="{{this.word[this.language].burgas}}, {{this.word[this.language].venues}}">
                    {{this.word[this.language].burgas}}</a>
                </li>
                <li id="tarnovo">
                  <a href="http://tarnovo.{{getHost()}}/"
                    title="{{this.word[this.language].tarnovo}}, {{this.word[this.language].venues}}">
                    {{this.word[this.language].tarnovo}}</a>
                </li>
                <li id="bansko">
                  <a href="http://bansko.{{getHost()}}/"
                    title="{{this.word[this.language].bansko}}, {{this.word[this.language].venues}}">
                    {{this.word[this.language].bansko}}</a>
                </li>
                <li id="bulgaria">
                  <a href="http://bulgaria.zavedenia.com/"
                    title="{{this.word[this.language].others}}, {{this.word[this.language].venues}}">
                    {{this.word[this.language].others}}</a>
                </li>
              </ul>
              <div id="map">
                <img width='730' height="461" src="assets/images/map.svg" alt="" />
                <a class="point point--big sofia"
                  href="https://sofia.zavedenia.com/">{{this.word[this.language].sofia}}</a>
                <a class="point point--medium plovdiv"
                  href="https://plovdiv.zavedenia.com/">{{this.word[this.language].plovdiv}}</a>
                <a class="point point--medium varna"
                  href="https://varna.zavedenia.com/">{{this.word[this.language].varna}}</a>
                <a class="point burgas" href="https://burgas.zavedenia.com/">{{this.word[this.language].burgas}}</a>
                <a class="point turnovo" href="http://tarnovo.zavedenia.com/">{{this.word[this.language].tarnovo}}</a>
                <a class="point bansko" href="http://bansko.zavedenia.com/">{{this.word[this.language].bansko}}</a>
              </div>
            </div>
          </div>
        </div>
        <button id="search-button-mobile" (click)="toggleSearch()" aria-label="Toggle mobile search bar">
          <i class="fa fa-search"></i>
        </button>
      </div>
      <div id="nav-center">
        <div id="search">
          <form id="search-form" [formGroup]="searchForm" (ngSubmit)="onSubmit()">
            <div class="search-wrap">
              <button id="search-button" aria-label="submit search form">
                <i class="fa fa-search"></i>
              </button>
              <div class="search-input">
                <input formControlName="searchText" type="text" id="search-input" class="form-input"
                  placeholder="{{this.word[this.language].searchPlaceHolder}}">
              </div>
            </div>
          </form>
          <button class="close-mobile-search" aria-label="dismiss mobile search bar" (click)="toggleSearch()"><i
              class="fa fa-times"></i></button>
        </div>

        <ul *ngIf="false" class="main-nav-links order-booky-links hidden-sm hidden-xs">
          <a href="https://order.bg/sofia/" rel="nofollow" target="_blank" class="cta-order-booky orderbg" title="{{this.word[this.language].foodForHome}}">
            <img src="assets/images/order-tiny.png" alt="booky">
            <span>{{this.word[this.language].foodForHome}}</span>
          </a>
          <a href="https://booky.bg/sofia/" rel="nofollow" target="_blank" class="cta-order-booky bookybg" title="{{this.word[this.language].bookTable}}">
            <img src="assets/images/booky-tiny.png" alt="booky">
            <span>{{this.word[this.language].bookTable}}</span>
          </a>
        </ul>
        <ul *ngIf="false" class="main-nav-links media-links hidden-sm hidden-xs">
          <li class="social-media">
            <a href="https://facebook.com/zavedenia" rel="nofollow" target="_blank" class="social-media-link">
              <i class="fa fa-facebook" aria-hidden="true"></i>
            </a>
          </li>
          <li class="social-media">
            <a href="https://twitter.com/zavedenia" rel="nofollow" target="_blank" class="social-media-link">
              <i class="fa fa-twitter" aria-hidden="true"></i>
            </a>
          </li>
          <li class="social-media">
            <a href="https://instagram.com/zavedenia_bg" rel="nofollow" target="_blank" class="social-media-link">
              <i class="fa fa-instagram" aria-hidden="true"></i>
            </a>
          </li>
          <li class="social-media">
            <a href="https://www.youtube.com/user/zavedenia" rel="nofollow" target="_blank" class="social-media-link">
              <i class="fa fa-youtube-play" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>
      <div id="nav-end" class="hidden-md hidden-xs ">
        <ul class="main-nav-links action-links">
          <li [style]="{'margin-left': !this.isOutside ? 'initial' : 'auto'}" *ngIf="this.currentCity !== 'skopje'" class="language">
            <button id="language-text" (click)="changeLanguage()" aria-label="Change language button">{{this.translationService.language == 'en' ? 'BG' : 'EN'}}</button>
          </li>
          <li  [style]="{'margin-left': !this.isOutside ? 'initial' : 'auto'}" *ngIf="this.currentCity === 'skopje'" class="language">
            <button id="language-text" (click)="changeLanguage()" aria-label="Change language button">{{this.translationService.language == 'en' ? 'MK' : 'EN'}}</button>
          </li>
          <li *ngIf="!this.isOutside" class="add-venue">
            <!-- {{currentCity}} -->
            <a href="https://login.zavedenia.com/plans" title="{{this.word[this.language].for}}  {{this.word[this.language].theBusiness}}, {{this.word[this.language].zavedenia}}">{{this.word[this.language].for}}  {{this.word[this.language].theBusiness}}</a>
          </li>
          <li *ngIf="!this.isOutside" id="loginDropDown">
           <a href="https://login.zavedenia.com/" title="{{this.word[this.language].for}} {{this.word[this.language].zavedenia}}"> <i
              class="fa fa-sign-in"></i>{{this.word[this.language].login}}
              </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<categories-nav
appFixScroll
[howFar]="60 " [startingPos]="0"
 *ngIf="(this.currentCity && this.reloadCategories) != undefined" id="category-nav"></categories-nav>
<app-mobile-menu *ngIf="displayMobile" id="mobile-menu" [mobileOpened]="false"></app-mobile-menu>
